import { createAsyncThunk } from '@reduxjs/toolkit';
import { actions as notificationActions } from '@bufferapp/notifications/lib/reducer';
import callRpc from '~/utils/call-rpc';
import { logError } from '~/utils/logError';

export const refreshSingleProfile = createAsyncThunk<
  unknown,
  { profileId: string; message?: string }
>(
  'profiles/refreshSingleProfile',
  async ({ profileId, message }, { dispatch, rejectWithValue }) => {
    try {
      const response = await callRpc('singleProfile', {
        profileId,
      });

      if (!response) {
        throw new Error('No profile was returned.');
      }

      if (message) {
        dispatch(
          notificationActions.createNotification({
            notificationType: 'success',
            message,
          })
        );
      }

      return response;
    } catch (error) {
      logError(error);

      return rejectWithValue(null);
    }
  }
);
